// Strings do Turminha Educa
export const Strings = {
  // Login
  LOGIN: {
    TITLE: "Turminha Educa",
    SUBTITLE: "Área de Membros",
    EMAIL_PLACEHOLDER: "Email",
    PASSWORD_PLACEHOLDER: "Senha",
    LOGIN_BUTTON: "Entrar",
    SIGNUP_BUTTON: "Criar conta",
    FORGOT_PASSWORD: "Esqueci a senha",
    LOGGING_IN: "Entrando...",
    ERROR_MESSAGE: "Email ou senha incorretos"
  },
  
  // Signup
  SIGNUP: {
    TITLE: "Criar Conta",
    SUBTITLE: "Junte-se à Turminha Educa",
    NAME_PLACEHOLDER: "Nome completo",
    EMAIL_PLACEHOLDER: "Email",
    PASSWORD_PLACEHOLDER: "Senha",
    CONFIRM_PASSWORD_PLACEHOLDER: "Confirmar senha",
    CREATE_BUTTON: "Criar conta",
    LOGIN_BUTTON: "Já tenho uma conta",
    CREATING_ACCOUNT: "Criando conta..."
  },
  
  // Forgot Password
  FORGOT_PASSWORD: {
    TITLE: "Esqueci minha senha",
    SUBTITLE: "Digite seu email para receber instruções de recuperação",
    EMAIL_PLACEHOLDER: "Email",
    SEND_BUTTON: "Enviar instruções",
    BACK_TO_LOGIN: "Voltar ao login",
    SENDING: "Enviando...",
    SUCCESS_TITLE: "Email enviado!",
    SUCCESS_MESSAGE: "Enviamos instruções para recuperar sua senha. Verifique sua caixa de entrada."
  },
  
  // Geral
  COMMON: {
    LOADING: "Carregando...",
    ERROR: "Erro",
    SUCCESS: "Sucesso",
    CANCEL: "Cancelar",
    CONFIRM: "Confirmar",
    SAVE: "Salvar",
    EDIT: "Editar",
    DELETE: "Excluir",
    BACK: "Voltar"
  }
};
